
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.49998 8.62002V15.38L5.11998 12L8.49998 8.62002ZM3.70998 11.29C3.31998 11.68 3.31998 12.31 3.70998 12.7L8.29998 17.29C8.91998 17.92 9.99998 17.48 9.99998 16.59V7.41002C9.99998 6.52002 8.91998 6.07002 8.28998 6.70002L3.70998 11.29ZM14 7.41002V16.58C14 17.47 15.08 17.92 15.71 17.29L20.3 12.7C20.69 12.31 20.69 11.68 20.3 11.29L15.71 6.70002C15.08 6.08002 14 6.52002 14 7.41002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-switch-left`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSwitchLeft

    ```js
    <b-new-b-icon-switch-left />
    ```
</docs>


